module.exports = __webpack_public_path__ + "static/media/userIcon.83dae1d4.svg";